import {
    DataRecordValue,
    DataRecord,
    getMetricLabel,
    getColumnLabel,
} from '@superset-ui/core';
import { EChartsCoreOption, MapSeriesOption, number } from 'echarts';

import * as echarts from 'echarts';
import { GeoJSONSourceInput } from 'echarts/types/src/coord/geo/geoTypes';

import {
  DEFAULT_FORM_DATA as DEFAULT_CHART_FORM_DATA,
  EchartsMapChartProps,
  EchartsMapFormData,
  MapChartTransformedProps,
} from './types';
import { DEFAULT_LEGEND_FORM_DATA } from '../../../types';
import {
    extractGroupbyLabel,
} from '../../../utils/series';

  
export default function transformProps(
    chartProps: EchartsMapChartProps,
): MapChartTransformedProps {
    const { formData, height, hooks, queriesData, width } =
      chartProps;
    const data: DataRecord[] = queriesData[0].data || [];
  
    const {
      groupby,
      metric = '',
      tooltipFormat,
      geojson: geoJSONString
    }: EchartsMapFormData = {
      ...DEFAULT_LEGEND_FORM_DATA,
      ...DEFAULT_CHART_FORM_DATA,
      ...formData,
    };
    const metricLabel = getMetricLabel(metric);
    const groupbyLabels = Array.isArray(groupby) ? groupby.map(getColumnLabel)
      : [groupby].map(getColumnLabel);

    const labelMap = data.reduce(
      (acc: Record<string, DataRecordValue[]>, datum) => {
        const label = extractGroupbyLabel({
          datum,
          groupby: groupbyLabels,
          coltypeMapping: {},
        });
        return {
          ...acc,
          [label]: groupbyLabels.map(col => datum[col]),
        };
      },
      {},
    );
  
    const { setDataMask = () => {} } = hooks;

    let seriesMin = NaN;
    let seriesMax = NaN;
    const seriesData = data.map(datum => {
      const label = extractGroupbyLabel({
        datum,
        groupby: groupbyLabels,
        coltypeMapping: {},
      });

      seriesMin = !Number.isNaN(seriesMin) ?
        Math.min(seriesMin, number.numericToNumber(datum[metricLabel]))
        : number.numericToNumber(datum[metricLabel]);
      seriesMax = !Number.isNaN(seriesMax) ?
        Math.max(seriesMax, number.numericToNumber(datum[metricLabel]))
        : number.numericToNumber(datum[metricLabel]);
      
      return {
        name: label,
        value: datum[metricLabel]
      };
    });
    
    const geoJsonData = JSON.parse(geoJSONString);

    echarts.registerMap('customGeoJSON', geoJsonData as GeoJSONSourceInput);
  
    const series: MapSeriesOption[] = [
      {
        name: metricLabel,
        type: 'map',
        roam: true,
        map: 'customGeoJSON',
        animation: true,
        emphasis: {
          label: {
            show: true
          }
        },
        // @ts-ignore
        data: seriesData
      },
    ];
  
    const echartOptions: EChartsCoreOption = {
      tooltip: {
        trigger: 'item',
        formatter: tooltipFormat
      },
      visualMap: {
        left: 'right',
        min: Math.round(seriesMin * .8),
        max: Math.round(seriesMax * 1.2),
        inRange: {
          color: [...DEFAULT_CHART_FORM_DATA.colorRange]
        },
        text: ['High', 'Low'],
        calculable: true
      },
      series,
    };

    return {
      formData,
      width,
      height,
      echartOptions,
      setDataMask,
      labelMap,
      groupby
    };
}
  